import styled from 'styled-components';

export const MediaSourceRow = styled.div`
    margin-bottom: 0.75rem;
`;

export const MediaFieldsRow = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    align-items: start;

    &.is-netwalk,
    &.is-embed,
    &.is-uploaded {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 0.5rem;
    }

    &.is-netwalk > :first-child,
    &.is-embed > :first-child,
    &.is-uploaded > :first-child {
        flex: 0 1 30rem;
        max-width: 30rem;
        min-width: 0;
    }

    .media-action {
        align-self: end;
        display: flex;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .media-action > div,
    .media-action .ant-upload,
    .media-action .ant-upload-select {
        width: 100%;
    }

    .media-source-action {
        align-self: end;
        flex: 0 0 auto;
        margin-bottom: 0.5rem;
    }

    .media-upload-item {
        min-width: 0;
    }

    @media (max-width: 576px) {
        .media-source-action {
            align-self: start;
        }
    }
`;

export const ArtMediaFieldControl = styled.div`
    max-width: 30rem;
    width: 100%;
`;

export const ArtMediaUploadArea = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.LightBlueBackground};
    padding: 1rem;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.PrimaryColor};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-size: ${(props) => props.theme.FontSizeBase};
    color: ${(props) => props.theme.PrimaryColor};
    cursor: pointer;
    transition: all 0.3s ease;
`;
